import { useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { apiRequest } from "src/async/apiUtils";
import InformationAlert from "src/components/Shared/Alerts/InformationAlert";
import Button from "src/components/Shared/Buttons/Button";
import Input from "src/components/Shared/Forms/Inputs/Input";
import RadioGroup from "src/components/Shared/Forms/Inputs/RadioGroup";

const UserPasswordChange = ({ userDetails = null }) => {
  const jsonData = {
    old_password: "",
    password: "",
    confirm_password: "",
    send_email: true,
  };

  const [formData, setFormData] = useState(jsonData);
  const [isDisabled, setIsDisabled] = useState(false);

  const onClear = () => {
    setFormData(jsonData);
  };

  const onHandleChange = (key, value) => {
    setFormData((prevData) => ({ ...prevData, [key]: value }));
  };

  const onSubmit = async () => {
    try {
      setIsDisabled(true);
      const { data } = await apiRequest("PUT", "/users/:user_id/password", { body: formData, params: { user_id: userDetails?._id } });
      toast.success(data.message);
      setFormData((pre) => ({ ...pre, password: "", confirm_password: "" }));
    } catch (error) {
      toast.error(error.message);
    } finally {
      setIsDisabled(false);
    }
  };

  return (
    <div className="animate-fade-in">
      <div className="relative my-3 w-full">
        <RadioGroup
          title=""
          subtitle=""
          options={[
            { id: "send-email", title: "Send reset password mail" },
            { id: "manual", title: "Manually set password" },
          ]}
          defaultChecked={formData?.send_email ? "send-email" : "manual"}
          onChange={(id) => {
            onHandleChange("send_email", id === "send-email");
          }}
          containerClasses="ml-1"
          layout="horizontal"
        />
      </div>
      {formData?.send_email && (
        <div className="animate-fade-in w-full">
          <InformationAlert
            type="default"
            content={
              <div>
                A reset password mail will be sent to the <strong>{userDetails?.name}'s</strong> email address with a link to set up their password.
              </div>
            }
          />
        </div>
      )}
      {!formData?.send_email && (
        <div className="animate-fade-in grid w-full grid-cols-2 gap-x-4">
          <div className="w-full">
            <Input
              autocomplete="off"
              name="password"
              label="Password"
              inline={true}
              type="password"
              value={formData?.password}
              onChange={(e) => setFormData((prevData) => ({ ...prevData, password: e.target.value.replace(/\s/g, "") }))}
            />
          </div>
          <div className="w-full">
            <Input
              name="password"
              label="Confirm Password"
              inline={true}
              type="password"
              value={formData?.confirm_password}
              onChange={(e) => setFormData((prevData) => ({ ...prevData, confirm_password: e.target.value.replace(/\s/g, "") }))}
            />
          </div>
        </div>
      )}
      <div className="mt-5 flex w-full justify-end gap-x-3 pt-3">
        <Button
          version="gray"
          type="button"
          disabled={isDisabled}
          onClick={onClear}>
          Clear
        </Button>
        <Button
          type="button"
          onClick={onSubmit}
          loading={isDisabled}>
          Submit
        </Button>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    me: state.auth.user,
  };
};
export default connect(mapStateToProps, {})(UserPasswordChange);
